import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './PremiumRequiredCard.css'; // Importa el CSS

const PremiumRequiredCard = () => {
    const { t } = useTranslation(); // Hook para traducciones

    return(
        <div className="premium-card">
            <h4 className="premium-title">{t('premiumRequired')}</h4>
            <p className="premium-message">{t('upgradeToAccess')}</p>
            <Link to="/plans" className="btn-upgrade">
                {t('plans')}
                <i className="ph-arrow-circle-right ms-2"></i>
            </Link>
        </div>
    );
};

export default PremiumRequiredCard;